(function () {
  'use strict';
  var pages = document.querySelectorAll('[data-rn-contact]');
  if (!pages.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionOff = document.documentElement.getAttribute('data-rn-motion') === 'off';

  pages.forEach(function (page) {
    var video = page.querySelector('[data-rn-contact-video]');
    var form = page.querySelector('.rn-contact__form');
    var nav = page.querySelector('[data-rn-nav]');
    var navSentinel = page.querySelector('[data-rn-contact-nav-sentinel]');
    var menu = page.querySelector('[data-rn-menu]');
    var openButton = page.querySelector('[data-rn-menu-open]');
    var closeButton = page.querySelector('[data-rn-menu-close]');
    var previousFocus = null;
    var hero = page.querySelector('.rn-contact__hero');
    var heroMedia = page.querySelector('.rn-contact__hero-media');
    var conversation = page.querySelector('.rn-contact__conversation');
    var formColumn = page.querySelector('.rn-contact__form-column');
    var mobileLayout = window.matchMedia('(max-width: 749px)');

    function placeContactForm() {
      if (!hero || !heroMedia || !conversation || !formColumn) return;
      if (mobileLayout.matches) hero.insertBefore(formColumn, heroMedia);
      else conversation.appendChild(formColumn);
    }

    placeContactForm();
    if (typeof mobileLayout.addEventListener === 'function') mobileLayout.addEventListener('change', placeContactForm);
    else if (typeof mobileLayout.addListener === 'function') mobileLayout.addListener(placeContactForm);

    if (nav && navSentinel && 'IntersectionObserver' in window) {
      var navObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          nav.classList.toggle('is-scrolled', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      navObserver.observe(navSentinel);
    }

    if (menu && openButton && closeButton) {
      function focusableItems() {
        return Array.prototype.slice.call(menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      }

      function setMenu(open) {
        menu.classList.toggle('is-open', open);
        menu.setAttribute('aria-hidden', String(!open));
        openButton.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) {
          previousFocus = document.activeElement;
          closeButton.focus();
        } else if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus();
        }
      }

      openButton.addEventListener('click', function () { setMenu(true); });
      closeButton.addEventListener('click', function () { setMenu(false); });
      menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) setMenu(false);
      });
      document.addEventListener('keydown', function (event) {
        if (!menu.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          setMenu(false);
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusableItems();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    if (video) {
      if (reduceMotion || motionOff) {
        video.pause();
        video.removeAttribute('autoplay');
      } else if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.18 });
        videoObserver.observe(video);
      }
    }

    if (form) {
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        form.classList.add('is-sending');
        form.setAttribute('aria-busy', 'true');
        var submit = form.querySelector('.rn-contact__submit');
        if (submit) submit.disabled = true;
      });
    }
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.rn-contact__form.is-sending').forEach(function (form) {
      form.classList.remove('is-sending');
      form.removeAttribute('aria-busy');
      var submit = form.querySelector('.rn-contact__submit');
      if (submit) submit.disabled = false;
    });
  });
})();
